import {
  DeliveryZonesScope,
  ProductRestrictionType,
  ShippingRestrictionScope,
  WeightRestrictionType,
  ValueRestrictionType,
} from '@tiendanube/common/src/enums';
import { ShippingRestrictionFormValues } from '../types';

export const SHIPPING_RESTRICTION_INITIAL_VALUES: ShippingRestrictionFormValues =
  {
    methodId: '',
    shippingMethodsScope: ShippingRestrictionScope.ALL,
    selectedShippingMethods: [],
    distributionCenterScope: ShippingRestrictionScope.ALL,
    deliveryZonesScope: DeliveryZonesScope.ALL,
    selectedZones: [],
    productRestrictionType: ProductRestrictionType.NO_RESTRICTION,
    weightRestrictionType: WeightRestrictionType.ALL_WEIGHTS,
    valueRestrictionType: ValueRestrictionType.ALL_VALUES,
  };
